import React from 'react';
import { createFromIconfontCN } from '@ant-design/icons';
import './index.less';
// antd 字体图标
const IconFont = createFromIconfontCN({
  scriptUrl: [
    '//at.alicdn.com/t/c/font_4285415_sn8f7xlx4kl.js', // 智鲤主应用
    '//at.alicdn.com/t/c/font_4446488_qaseljua1vk.js', // 智理主架构、标签其它icon
    '//at.alicdn.com/t/c/font_4559732_frluixtze9a.js', // Ai方案
    '//at.alicdn.com/t/c/font_4259049_2d3hwcmytxd.js',
    '//at.alicdn.com/t/c/font_4712168_rf73zrunjp.js', // 万鲤商联-AI版本
    '//at.alicdn.com/t/c/font_4567946_rr532somj2l.js', // 妙鲤
    '//oss.elebuys.com/iconfont/13/2f94b3aec6627ff4/iconfont.js',
  ],
});

interface MainProps {
  [key: string]: any;
  type: string;
}
const Icon: React.FC<MainProps> = (props) => <IconFont {...props} />;
export default Icon;
